import { withProps } from 'recompose';
import Item from './Item';
import getOwnerFullName from '../../utils/getOwnerFullName';

const OwnerItem = withProps(({ rip, value }) => ({
    value: getOwnerFullName(rip, value),
}))(Item);

export default OwnerItem;
